import React from "react";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import withShipment from "../../../withShipment";
import {statusSelector} from "../../../redux/selectors/global";
import {clearStatus} from "../../../redux/actions/global";
import LedgerTable from "./LedgerTable";
import {LEDGERS_PAGES} from "./constants";
import EditLedger from "./EditLedger";
import {
    exportLedgerSelector,
    ledgerDesyncSelector,
    ledgerPreviewSelector,
    ledgerSelector, ledgerSettingsSelector, loadingSelector, shippingSettingSelector,
    transactionCategoriesSelector,
    transactionLedgerSelector,
} from '../../../redux/selectors/accounting';
import {
    applyLedgerRefresh,
    checkLedgerUpdates,
    clearLedgerDesync,
    clearLedgerPreview,
    clearLedgerSettings,
    deleteEntry,
    deleteLedger,
    deleteLedgerByYear,
    deleteLedgerByYearAndCurrency, exportLedgers,
    fetchTransactionsLedger, getLedgerSettings, ledgerEntries,
    listAllLedgers, listShippingSettings,
    listTransactionCategories,
    previewLedgerRefresh,
    saveLedger, saveLedgerDesyncStatus, saveMarketplaceLedger,
    saveTransactionsLedger, updateEntry, updateLedger,
} from '../../../redux/actions/accounting';
import {userInfoSelector} from "../../../redux/selectors/auth";
import LedgerRuleForm from './LedgerRuleForm';
import LedgerAudit from "../audit/LedgerAudit";

class Ledger extends React.Component {
    constructor(props) {
        super(props);

        const currentYear = new Date().getFullYear();
        const startYear = 2023;
        const years = Array.from(
          { length: currentYear - startYear + 1 },
          (_, i) => (startYear + i).toString()
        );

        this.state = {
            currentPage: LEDGERS_PAGES.TABLE,
            feedbackBarOpen: false,
            error: false,
            transactionCategories:this.props.transactionCategories,
            ledgerEditing: {},
            ledgerNavStack: [],
            years: years,
            selectedYear: localStorage.getItem('selectedYear') || "2025",
            currency: ['CAD', 'USD', "Consolidated CAD"],
            selectedCurrency: localStorage.getItem('selectedCurrency') || 'CAD',
            supplierSummary: this.props.fetchTransactions.supplierSummary || [],
            customerSummary: this.props.fetchTransactions.customerSummary || [],
            bankAccountSummary: this.props.fetchTransactions.bankAccountSummary || [],
            outstandingChequesSummary: this.props.fetchTransactions.outstandingChequesSummary || [],
            creditCardBalancesSummary: this.props.fetchTransactions.creditCardBalancesSummary || [],
            salesSummary: this.props.fetchTransactions.salesSummary || [],
            carrierSummary: this.props.fetchTransactions.carrierSummary || [],
            ftlSummary: this.props.fetchTransactions.ftlSummary || [],
            marketplaceSummary: this.props.fetchTransactions.marketplaceSummary || [],
            carriers:[],
            accountNumbers: null,
            ledgerType: "",
            desyncMap: {},
        }
    }

    // The persisted desync flag comes back on each ledger from the server (list -> hasPendingChanges),
    // so the indicator is consistent across sessions and devices.
    deriveDesyncMapFromLedgers = (ledgers) => {
        const map = {};
        (ledgers || []).forEach((ledger) => {
            if (ledger && ledger.ledgerId) {
                map[ledger.ledgerId] = !!ledger.hasPendingChanges;
            }
        });
        return map;
    };

    handleCheckForUpdates = () => {
        this.props.checkLedgerUpdates({
            year: this.state.selectedYear,
            currency: this.state.selectedCurrency,
        });
    };

    // Clears a single ledger's desync flag — called right after the user applies that ledger's
    // refresh. Persists the cleared status server-side and refetches so the list stays in sync.
    clearLedgerDesyncEntry = (ledgerId) => {
        if (!ledgerId) return;
        const desyncMap = { ...this.state.desyncMap };
        delete desyncMap[ledgerId];
        this.setState({ desyncMap });
        this.props.saveLedgerDesyncStatus(
            {
                year: this.state.selectedYear,
                currency: this.state.selectedCurrency,
                statuses: [{ ledgerId, hasChanges: false }],
            },
            () => this.props.listAllLedgers({ currency: this.state.selectedCurrency, year: this.state.selectedYear })
        );
    };

    componentDidMount() {
        this.props.listShippingSettings()
        this.props.listAllLedgers({currency: this.state.selectedCurrency, year: this.state.selectedYear})

        this.props.listTransactionCategories()

        // Seed desync indicators from whatever the ledger list already carries.
        if (this.props.ledgers && this.props.ledgers.length > 0) {
            this.setState({ desyncMap: this.deriveDesyncMapFromLedgers(this.props.ledgers) })
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText){
            this.openFeedbackBar()
        }

        // The persisted desync flags arrive on each ledger from list() — keep the map in sync.
        if (prevProps.ledgers !== this.props.ledgers) {
            this.setState({ desyncMap: this.deriveDesyncMapFromLedgers(this.props.ledgers) });
        }

        if (prevProps.fetchTransactions.ftlSummary !== this.props.fetchTransactions.ftlSummary) {
            this.setState({
                ftlSummary : this.props.fetchTransactions.ftlSummary
            })
        }

        if (prevProps.fetchTransactions.marketplaceSummary !== this.props.fetchTransactions.marketplaceSummary) {
            this.setState({
                marketplaceSummary : this.props.fetchTransactions.marketplaceSummary
            })
        }

        if (prevProps.fetchTransactions.customerSummary !== this.props.fetchTransactions.customerSummary) {
            this.setState({
                customerSummary : this.props.fetchTransactions.customerSummary
            })
        }

         if (prevProps.fetchTransactions.bankAccountSummary !== this.props.fetchTransactions.bankAccountSummary) {
            this.setState({
                bankAccountSummary : this.props.fetchTransactions.bankAccountSummary
            })
        }

        if (prevProps.fetchTransactions.creditCardBalancesSummary !== this.props.fetchTransactions.creditCardBalancesSummary) {
            this.setState({
                creditCardBalancesSummary : this.props.fetchTransactions.creditCardBalancesSummary
            })
        }

         if (prevProps.fetchTransactions.outstandingChequesSummary !== this.props.fetchTransactions.outstandingChequesSummary) {
            this.setState({
                outstandingChequesSummary : this.props.fetchTransactions.outstandingChequesSummary
            })
        }



        if (prevProps.fetchTransactions.salesSummary !== this.props.fetchTransactions.salesSummary) {
            this.setState({
                salesSummary : this.props.fetchTransactions.salesSummary
            })
        }


        if (prevProps.fetchTransactions.supplierSummary !== this.props.fetchTransactions.supplierSummary) {
            this.setState({
                supplierSummary : this.props.fetchTransactions.supplierSummary
            })
        }

        if (prevProps.fetchTransactions.carrierSummary !== this.props.fetchTransactions.carrierSummary) {
            this.setState({
                carrierSummary : this.props.fetchTransactions.carrierSummary
            })
        }

        if (prevProps.ledgerEditing!== this.props.ledgerEditing && this.props.ledgerEditing) {
            this.setState({
                ledgerEditing: this.props.ledgerEditing
            })
        }

        //update state transactionCategories
        if (prevProps.transactionCategories !== this.props.transactionCategories) {
            this.setState({
                transactionCategories : this.props.transactionCategories
            })
        }
        //sort state transactionCategories by displayOrder
        if (prevState.transactionCategories !== this.state.transactionCategories) {
            this.setState({
                transactionCategories : this.state.transactionCategories.sort((a, b) => a.displayOrder - b.displayOrder)
            })
        }

    }

    handleLedgerType = (tab) =>{
        this.setState({ledgerType: tab},()=>{
            if(tab === "1"){
                this.setState({ledgerType: "Assets"})
                this.props.exportLedgers({ledgerType: "Assets",currency: this.state.selectedCurrency, year: this.state.selectedYear})
            } else if(tab === "2"){
                this.setState({ledgerType: "Liabilities"})
                this.props.exportLedgers({ledgerType: "Liabilities",currency: this.state.selectedCurrency, year: this.state.selectedYear})
            }else if(tab === "3"){
                this.setState({ledgerType: "Income"})
                this.props.exportLedgers({ledgerType: "Income",currency: this.state.selectedCurrency, year: this.state.selectedYear})
            } else if(tab === "4"){
                this.setState({ledgerType: "Expenses"})
                this.props.exportLedgers({ledgerType: "Expenses",currency: this.state.selectedCurrency, year: this.state.selectedYear})
            } else if(tab === "5"){
                this.setState({ledgerType: "Equity"})
                this.props.exportLedgers({ledgerType: "Equity",currency: this.state.selectedCurrency, year: this.state.selectedYear})
            }

        })
    }

    handleChange = (event) => {
        const newCurrency = event.target.value
        localStorage.setItem('selectedCurrency', newCurrency)
        this.props.clearLedgerDesync()
        this.setState({ desyncMap: {} })
        if(this.state.currentPage === 'Edit Ledgers'){
            this.setState({  selectedCurrency: event.target.value },()=>{
                const data = {ledgerId: this.state.ledgerEditing.ledgerId, year: this.state.selectedYear,  currency: this.state.selectedCurrency}
                this.props.ledgerEntries(data)

            })
        }else{
            this.setState({ selectedCurrency: event.target.value },()=>{
                this.props.listAllLedgers({ currency: this.state.selectedCurrency, year: this.state.selectedYear})
                this.props.exportLedgers({ledgerType: this.state.ledgerType,currency: this.state.selectedCurrency, year: this.state.selectedYear})
            })
        }

    }

    handleSave = (ledgers) => {
      this.props.saveLedger({ledgers:ledgers, currency: this.state.selectedCurrency, year: this.state.selectedYear})
      this.setCurrentPage(LEDGERS_PAGES.TABLE, {})
    }

     getLastTransactionBalance = (transactions) => {
        if (transactions.length === 0) return null;
        const lastTransaction = transactions[transactions.length - 1];
        return lastTransaction.balance;
    };

    handleSaveTransactionsLedger = (transactions,ledgerId) => {
        const lastBalance = this.getLastTransactionBalance(transactions)
        const entry = {
            year: this.state.selectedYear,
            entries: transactions.map(transaction => ({
                date: transaction.date,
                balance: parseFloat(transaction.balance),
                description: transaction.description,
                debit: parseFloat(transaction.debit),
                credit: parseFloat(transaction.credit),
                currency: this.state.selectedCurrency,
                transactionId: transaction.transactionId,
                journalEntryId: transaction?.journalEntryId,
                note: transaction.note || ''
            })),
            balance: lastBalance // convert to number
        };

        const data = { ledgerEntries: entry, ledgerId: ledgerId, currency: this.state.selectedCurrency, year: this.state.selectedYear}
       this.props.saveTransactionsLedger(data,()=>{
           const ledgerData = {ledgerId: ledgerId, year: this.state.selectedYear,  currency: this.state.selectedCurrency}
           this.props.ledgerEntries(ledgerData)
       })

       // this.setCurrentPage(LEDGERS_PAGES.TABLE, {})
    }

    handleYearChange = (event) => {
        const newYear = event.target.value
        localStorage.setItem('selectedYear', newYear)
        this.props.clearLedgerDesync()
        this.setState({ desyncMap: {} })
        if(this.state.currentPage === 'Edit Ledgers'){
            this.setState({ selectedYear: event.target.value },()=>{
                const data = {ledgerId: this.state.ledgerEditing.ledgerId, year: this.state.selectedYear,  currency: this.state.selectedCurrency}
                this.props.ledgerEntries(data)
            })
        }else{
            this.setState({ selectedYear: event.target.value },()=>{
                this.props.listAllLedgers({ currency: this.state.selectedCurrency, year: this.state.selectedYear})
                this.props.exportLedgers({ledgerType: this.state.ledgerType,currency: this.state.selectedCurrency, year: this.state.selectedYear})

            })
        }

    }


    setCurrentPage = (newPage, data) => {
        if (newPage === LEDGERS_PAGES.FORM) {
                this.props.clearLedgerSettings();
        }

        this.setState({
            currentPage: newPage,
            ledgerEditing: data,
            ledgerNavStack: [],
        });
    }

    // Navigate into a sub-ledger referenced by a ledger entry, remembering the
    // parent ledger so the Back button can return to it.
    navigateToSubLedger = (ledger) => {
        if (!ledger) return;
        this.setState(prevState => ({
            ledgerNavStack: [...prevState.ledgerNavStack, prevState.ledgerEditing],
            ledgerEditing: ledger,
            currentPage: LEDGERS_PAGES.EDIT,
        }));
    }

    // Back handler for the EditLedger view: pop to the parent ledger if we drilled
    // into a sub-ledger, otherwise fall back to the ledger list table.
    goBackFromEditLedger = () => {
        const { ledgerNavStack, selectedCurrency, selectedYear } = this.state;
        if (ledgerNavStack.length > 0) {
            const parent = ledgerNavStack[ledgerNavStack.length - 1];
            this.setState(prevState => ({
                ledgerNavStack: prevState.ledgerNavStack.slice(0, -1),
                ledgerEditing: parent,
                currentPage: LEDGERS_PAGES.EDIT,
            }));
        } else {
            this.setState({
                currentPage: LEDGERS_PAGES.TABLE,
                ledgerEditing: {},
                ledgerNavStack: [],
            });
            this.props.listAllLedgers({ currency: selectedCurrency, year: selectedYear });
        }
    }

    displayForm = ()=> {
        return (
        <LedgerRuleForm
          allLedgers={this.props.ledgers}
          setCurrentPage={this.setCurrentPage}
          ledger={this.state.ledgerEditing}
          year={this.state.selectedYear}
          currency={this.state.selectedCurrency}
          updateLedger={this.props.updateLedger}
          deleteEntry={this.props.deleteEntry}
          categories={this.state.transactionCategories}
          ledgerType={this.state.ledgerType}
          deleteLedger={this.props.deleteLedger}
          deleteLedgerByYear={this.props.deleteLedgerByYear}
          getLedgerSettings={this.props.getLedgerSettings}
          ledgerSettings={this.props.ledgerSettings}
        />
        )
    }


    displayTable = () => {
            return (
                <LedgerTable
                    categories={this.state.transactionCategories}
                    listLedgers={this.props.listAllLedgers}
                    deleteLedgerByYearAndCurrency={this.props.deleteLedgerByYearAndCurrency}
                    years={this.state.years}
                    selectedYear={this.state.selectedYear}
                    handleYearChange={this.handleYearChange}
                    ledgers={this.props.ledgers}
                    setCurrentPage={this.setCurrentPage}
                    openFeedbackBar={this.openFeedbackBar}
                    currency={this.state.currency}
                    selectedCurrency={this.state.selectedCurrency}
                    handleChange={this.handleChange}
                    deleteLedger={this.props.deleteLedger}
                    updateLedger={this.props.updateLedger}
                    settings={this.props.shippingSettings}
                    fetchTransactionsLedger={this.props.fetchTransactionsLedger}
                    handleSave={this.handleSaveTransactionsLedger}
                    handleLedgerType={this.handleLedgerType}
                    exportAllLedgers={this.props.exportAllLedgers}
                    ledgerType={this.state.ledgerType}
                    onCheckForUpdates={this.handleCheckForUpdates}
                    desyncMap={this.state.desyncMap}
                    hasCheckedUpdates={(this.props.ledgerDesync || []).length > 0}
                    loadingData={this.props.loadingData}
                />
            )
    }

    displayEditLedger = () => {
        return (
            <EditLedger
                  allLedgers={this.props.ledgers}
                  loadingData={this.props.loadingData}
                  listLedgers={this.props.listAllLedgers}
                  years={this.state.years}
                  handleYearChange={this.handleYearChange}
                  selectedYear={this.state.selectedYear}
                  ledger={this.state.ledgerEditing}
                  handleSave={this.handleSaveTransactionsLedger}
                  setCurrentPage={this.setCurrentPage}
                  navigateToSubLedger={this.navigateToSubLedger}
                  goBack={this.goBackFromEditLedger}
                  ledgerNavStack={this.state.ledgerNavStack}
                  openFeedbackBar={this.openFeedbackBar}
                  fetchTransactionsLedger={this.props.fetchTransactionsLedger}
                  fetchTransactions={this.props.fetchTransactions}
                  carrierSummary={this.state.carrierSummary}
                  supplierSummary={this.state.supplierSummary}
                  customerSummary={this.state.customerSummary}
                  bankAccountSummary={this.state.bankAccountSummary}
                  outstandingChequesSummary={this.state.outstandingChequesSummary}
                  marketplaceSummary={this.state.marketplaceSummary}
                  ftlSummary={this.state.ftlSummary}
                  stockSummary={this.props.fetchTransactions.stockSummary}
                  ledgerEntries={this.props.ledgerEntries}
                  previewLedgerRefresh={this.props.previewLedgerRefresh}
                  applyLedgerRefresh={this.props.applyLedgerRefresh}
                  clearLedgerPreview={this.props.clearLedgerPreview}
                  clearLedgerDesyncEntry={this.clearLedgerDesyncEntry}
                  ledgerPreview={this.props.ledgerPreview}
                  currency={this.state.currency}
                  selectedCurrency={this.state.selectedCurrency}
                  handleChange={this.handleChange}
                  settings={this.props.shippingSettings}
                  lastUpdated={this.props.fetchTransactions.lastUpdated}
                  updateEntry={this.props.updateEntry}
                  deleteEntry={this.props.deleteEntry}
                  categories={this.state.transactionCategories}
                  saveMarketplaceLedger={this.props.saveMarketplaceLedger}
                  salesSummary={this.state.salesSummary}
                  creditCardBalancesSummary={this.state.creditCardBalancesSummary}
            />
        )
    }

    displayAudit = () => {
        return (
            <LedgerAudit
                onBack={() => this.setCurrentPage(LEDGERS_PAGES.TABLE, {})}
            />
        )
    }

    displayCurrentPage = () => {
        switch (this.state.currentPage) {
            case LEDGERS_PAGES.TABLE:
                return this.displayTable()
            case LEDGERS_PAGES.FORM:
              return this.displayForm()
            case LEDGERS_PAGES.EDIT:
                return this.displayEditLedger()
            case LEDGERS_PAGES.AUDIT:
                return this.displayAudit()
            default:
                console.log("Error: current transactions page doesn't exist")
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }

    openFeedbackBar = () => {
        this.setState({feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false }, () => {
            this.props.clearStatus()
        })
    }

    render() {
        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.props.status?.success ? 'success' : 'error'}
                    message={this.props.status?.statusText}
                />
                {this.displayCurrentPage()}
            </React.Fragment>
        )
    }
}


const mapStateToProps = (state) => ({
    status: statusSelector(state),
    transactionCategories: transactionCategoriesSelector(state),
    ledgers: ledgerSelector(state),
    fetchTransactions: transactionLedgerSelector(state),
    ledgerPreview: ledgerPreviewSelector(state),
    ledgerDesync: ledgerDesyncSelector(state),
    shippingSettings: shippingSettingSelector(state),
    loadingData: loadingSelector(state),
    user: userInfoSelector(state),
    exportAllLedgers: exportLedgerSelector(state),
    ledgerSettings: ledgerSettingsSelector(state)

})


const actionCreators = {
    clearStatus,
    listTransactionCategories,
    listAllLedgers,
    saveLedger,
    saveTransactionsLedger,
    fetchTransactionsLedger,
    deleteLedgerByYear,
    deleteLedgerByYearAndCurrency,
    ledgerEntries,
    previewLedgerRefresh,
    applyLedgerRefresh,
    clearLedgerPreview,
    checkLedgerUpdates,
    clearLedgerDesync,
    saveLedgerDesyncStatus,
    deleteLedger,
    updateLedger,
    listShippingSettings,
    updateEntry,
    deleteEntry,
    saveMarketplaceLedger,
    exportLedgers,
    getLedgerSettings,
    clearLedgerSettings
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, Ledger);